/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class TenantComplianceTrendWidgetConfiguration extends models.BaseChartWidgetConfigurationModel {
    constructor() {
        super();
        this.setDiscriminator("TenantComplianceTrendWidgetConfiguration");
    }

    getFixupPrototypeFunction() { return TenantComplianceTrendWidgetConfiguration.fixupPrototype; }

    static newInstance(model: Partial<TenantComplianceTrendWidgetConfiguration>): TenantComplianceTrendWidgetConfiguration {
        let obj = Object.assign(new TenantComplianceTrendWidgetConfiguration(), model);
        TenantComplianceTrendWidgetConfiguration.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<TenantComplianceTrendWidgetConfiguration>): TenantComplianceTrendWidgetConfiguration {
        if (!model) return null;
        return TenantComplianceTrendWidgetConfiguration.newInstance(<TenantComplianceTrendWidgetConfiguration> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: TenantComplianceTrendWidgetConfiguration) {
        if (!obj) return;

        models.TenantComplianceTrendWidgetConfiguration.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: TenantComplianceTrendWidgetConfiguration): boolean {
        if (models.BaseChartWidgetConfigurationModel.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, TenantComplianceTrendWidgetConfiguration.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

}
